/**
 * The device bridge the staff app prints through (08-clients.md "Device bridge"). The
 * shells (Tauri, Capacitor) inject theirs as `window.qrkeyDeviceBridge`; in a plain
 * browser the dev print bridge (HTML receipt, print or save as PDF) is the
 * implementation. Screens depend on the `DeviceBridge` interface only.
 */
import type { DeviceBridge } from '@qrkey/device-bridge';
import { DevPrintBridge } from './dev-bridge.js';

declare global {
  interface Window {
    /** Set by a shell before the web bundle starts. */
    qrkeyDeviceBridge?: DeviceBridge;
  }
}

export interface StaffBridge {
  readonly bridge: DeviceBridge;
  /** The dev bridge when it is the one in use (it keeps what it "printed" for the screen). */
  readonly dev: DevPrintBridge | null;
}

export function resolveStaffBridge(): StaffBridge {
  const injected = typeof window === 'undefined' ? undefined : window.qrkeyDeviceBridge;
  if (injected) return { bridge: injected, dev: null };
  const dev = new DevPrintBridge();
  return { bridge: dev, dev };
}
